
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: "",
props: [""],
data() {
return {


telNo: '语音报警通知固话：01021364689 或 01021364720',
apiurl: "",
loading: false,
showMap: false,
coord: '',
bindForm: {
imei: "",
deviceName: "",
address: "",
mobile1: "",
mobile2: "",
mobile3: "",
mobile4: "",
mobile5: "",
mobile6: "",
latng: ''
},
deviceData: {},
};
},
directives: {
TransferDom
},
components: { Loading, Toast, Checker, CheckerItem },
created() {
let _this = this
window.addEventListener('message', function(event) {

var loc = event.data;
if (loc && loc.module === 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
_this.mapConfirm(loc.latlng.lat, loc.latlng.lng);
}
}, false);
},
beforeMount() {},
mounted() {
if (this.$route.params.data) {
this.deviceData = JSON.parse(this.$route.params.data);
if (this.deviceData) {
this.bindForm.imei = this.deviceData.imei;
}
}
this.$http.get("./static/api/api.json").then(response => {
this.apiurl = response.api;
this.myUrl = location.href.split("#")[0];
this.getWxJsapiSignature();
});
},
methods: {
getLocation(){
let _this = this
wx.getLocation({
type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success: function (res) {
console.log(' wx.getLocation===',res)
var latitude = res.latitude; 
var longitude = res.longitude; 
_this.coord = latitude + ',' + longitude;
var speed = res.speed; 
var accuracy = res.accuracy; 
}
});
},
cancelMap(){
this.bindForm.latng = ''
this.showMap = false
},
mapConfirm(lat,lng){
this.bindForm.latng = lat + ',' + lng;
this.showMap = false
},
openMap(){
this.getLocation()
this.showMap = true
},
onSubmit(values) {
this.sumbits()
},
getWxJsapiSignature() {
this.$http
.post(this.apiurl + "/web/member/getWxJsapiSignature",{url: this.myUrl})
.then(res => {
if (res.code === 0) {
this.wxconfigdata = res.data;
console.log('this.wxconfigdata',this.wxconfigdata)
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: this.wxconfigdata.appId, // 必填，公众号的唯一标识
timestamp: this.wxconfigdata.timestamp, // 必填，生成签名的时间戳
nonceStr: this.wxconfigdata.nonceStr, // 必填，生成签名的随机串
signature: this.wxconfigdata.signature, // 必填，签名
jsApiList: ["scanQRCode", "getLocation"] 
});
} else {
this.$vux.toast.text("拉取摄像头失败", "top");
}
});
},
getsys() {
var _this = this;
wx.ready(function() {
wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {

let result = res.resultStr; 
if (result && result.indexOf(',') !== -1 ) {
let results = result.split(',');
if (results.length && results.length >= 1) {
result = results[1]
}
}
_this.bindForm.imei = result;
}
});
});
},

getUrlCode(name) {
return (
decodeURIComponent(
(new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
location.href
) || [, ""])[1].replace(/\+/g, "%20")
) || null
);
},
sumbits() {
let _this = this
if (_this.bindForm.imei === '') {
_this.$vux.toast.text("请扫描设备二维码", "top");
return;
}
if (_this.bindForm.deviceName === '') {
_this.$vux.toast.text("请输入设备名称", "top");
return;
}
if (_this.bindForm.address === '') {
_this.$vux.toast.text("请输入绑定地址", "top");
return;
}
if (_this.bindForm.mobile1 === '') {
_this.$vux.toast.text("请输入主要报警手机号", "top");
return;
}
if ('' !== _this.bindForm.mobile2 || null !== _this.bindForm.mobile2) {
if (_this.bindForm.mobile2 === _this.bindForm.mobile1) {
_this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
if ('' !== _this.bindForm.mobile3 || null !== _this.bindForm.mobile3) {
if (_this.bindForm.mobile3 === this.bindForm.mobile1) {
_this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
if ('' !== _this.bindForm.mobile4|| null !== _this.bindForm.mobile4) {
if (_this.bindForm.mobile4 === this.bindForm.mobile1) {
_this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
if ('' !== _this.bindForm.mobile5|| null !== _this.bindForm.mobile5) {
if (_this.bindForm.mobile5 === this.bindForm.mobile1) {
_this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
if ('' !== _this.bindForm.mobile6|| null !== _this.bindForm.mobile6) {
if (_this.bindForm.mobile6 === this.bindForm.mobile1) {
_this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}







_this.loading = true;
let postData = this.bindForm;












_this.$http
.post(_this.apiurl + "/web/device/bind", postData)
.then(res => {
if (res.code === 0) {
_this.$vux.toast.text("绑定成功", "top");
let bindFormData = localStorage.getItem('bindFormData')
if (bindFormData != null) {
localStorage.removeItem('bindFormData')
}
_this.bindForm.imei = '';
_this.bindForm.deviceName = '';
_this.bindForm.address = '';
_this.bindForm.mobile1 = '';
_this.bindForm.mobile2 = '';
_this.bindForm.mobile3 = '';
_this.bindForm.mobile4 = '';
_this.bindForm.mobile5 = '';
_this.bindForm.mobile6 = '';
_this.bindForm.latng = '';
_this.$router.push({
name: "deviceList",
});
} else {
_this.$vux.toast.text(res.message, "top");
}
_this.loading = false;
});
}
},

watch: {}
};



// WEBPACK FOOTER //
// ./src/components/binding.vue